import { Checkbox, Form } from "@/atoms"
import { ANALYTIC_EVENTS } from "@/const/event.constants"
import { useLogger } from "@/hooks/useLogger"
import { useTranslation } from "@/hooks/useTranslation"
import { toGroupedValues } from "@/pages/IntegrationsPage/components/organisms/TicketingConfigurationTab"
import { toGitHubConfigurationPayload } from "./GitHubConfigurationItem.selector"
import { GITHUB_KEY_PREFIX } from "./GitHubConfigurationPage.constants"
import { GitHubIssuesSettings } from "./GitHubIssuesSettings"

import styles from "./GitHubConfigurationForm.module.scss"

import type { GitHubConfigurationFormProps } from "./GitHubConfigurationPage.types"

// One form for the PR comments and the GitHub issues settings, saved together
export const GitHubConfigurationForm = (
  props: GitHubConfigurationFormProps
) => {
  const { values, installationUrl, form, onFieldsChange, onUpdate } = props
  const {
    id,
    name,
    enableComments,
    issuesEnabled,
    issueNotificationSettings,
    issuesPermission
  } = values
  const { t } = useTranslation("translation", { keyPrefix: GITHUB_KEY_PREFIX })
  const { logger } = useLogger()

  return (
    <Form
      form={form}
      id={id}
      initialValues={{
        enableComments,
        issuesEnabled,
        ...toGroupedValues(issueNotificationSettings)
      }}
      onFieldsChange={onFieldsChange}
      onFinish={() => {
        // the notification fields are unmounted while issues are off; send them anyway
        const payload = toGitHubConfigurationPayload(
          id,
          form.getFieldsValue(true)
        )
        const { enableComments, issuesEnabled } = payload.data

        onUpdate(payload, { name })
        logger.info(ANALYTIC_EVENTS.INTEGRATIONS.GITHUB.UPDATE_CONFIGURATION, {
          enableComments,
          issuesEnabled
        })
      }}
    >
      <Form.Item
        name="enableComments"
        valuePropName="checked"
        className={styles.comments}
      >
        <Checkbox>{t("enableComments")}</Checkbox>
      </Form.Item>
      <GitHubIssuesSettings
        form={form}
        issuesEnabled={issuesEnabled}
        issuesPermission={issuesPermission}
        installationUrl={installationUrl}
      />
    </Form>
  )
}
